import { RECEIVE_REFERRAL_WIZARD_DATA } from '../actions/ReferralWizardActions';

const initialState = {
  preferredReceivers: [],
  preferralNetwork: null,
};

const ReferralWizardReducer = (state = initialState, action) => {
  if (action.type === RECEIVE_REFERRAL_WIZARD_DATA) {
    return {
      availableNetworks: action.availableNetworks,
      inboundReferrableSpecialties: action.inboundReferrableSpecialties,
    };
  }
  return state;
};

export default ReferralWizardReducer;
